import React from 'react'
import FadeIn from '../Animations/FadeIn'
const Overview = ({ overviewData }) => {
    return (
        <FadeIn customClass='overview-section'>
            <div className="header light _eleX">
                <h2>{overviewData?.Header}</h2>
            </div>
            <div className="description _eleX">
                <p>{overviewData?.Description}</p>
            </div>
        </FadeIn>
    )
}

export default Overview
